export {DataTableContent} from './data-table-content'
